import i18next from "i18next";

export function paymentLabel(v) {
  const x = String(v || "").trim().toLowerCase();
  if (!x) return "";
  if (x === "bank") return i18next.t("payment.method.bank");
  if (x === "cash") return i18next.t("payment.method.cash");
  if (x === "transfer") return i18next.t("payment.method.transfer");
  if (x === "card") return i18next.t("payment.method.card");
  return x;
}

function isAssignedOrLater(order) {
  const s = String(order?.status || "").toUpperCase();
  return !!s && !["NEW", "SEARCH_DRIVER"].includes(s);
}

function extractPaymentFromOrder(order) {
  const o = order && typeof order === "object" ? order : {};
  return (
    o?.meta?.selectedBid?.paymentFinal ||
    o?.meta?.paymentFinal ||
    o?.meta?.selectedBid?.payment ||
    o?.meta?.payment ||
    null
  );
}

/**
 * Канон:
 * - До ASSIGNED показываем нейтральный текст (финала нет).
 * - С ASSIGNED+ финал обязателен (backend fail-fast), поэтому можно считать "final exists".
 */
export function paymentIsFinal(order) {
  if (!isAssignedOrLater(order)) return false;
  const pm = extractPaymentFromOrder(order);
  // Финализация может быть флагом, но иногда важнее сам факт наличия paymentFinal.
  return !!(order?.meta?.paymentFinalized || order?.meta?.finalPaymentConfirmedAt || pm);
}

export function paymentTitleFromOrder(order) {
  if (!isAssignedOrLater(order)) {
    return i18next.t("payment.after_approval");
  }
  return i18next.t("payment.final_title");
}

export function paymentOfferItems(pm) {
  if (!pm || typeof pm !== "object") return [];
  const items = [];

  // способы оплаты
  if (pm.cashTransfer) items.push(i18next.t("payment.method.cash_transfer"));
  if (pm.bankNoVat) items.push(i18next.t("payment.method.bank_no_vat"));
  if (pm.bankWithVat) items.push(i18next.t("payment.method.bank_with_vat"));

  // Две точки оплаты: при загрузке + остаток на выгрузке
  const pp = pm.prepayPercent;
  const ppNum = (pp === null || pp === undefined || pp === "") ? null : Number(pp);
  if (Number.isFinite(ppNum) && ppNum >= 0) {
    const prepay = Math.max(0, Math.min(100, Math.round(ppNum)));
    const rest = 100 - prepay;

    items.push(i18next.t("payment.prepay_loading_line", { prepay }));
    items.push(i18next.t("payment.rest_unload_line", { rest }));
  }


  return items;
}

export function paymentItemsFromOrder(order) {
  const pm = extractPaymentFromOrder(order);
  return paymentOfferItems(pm);
}

export function paymentSummary(order) {
  return paymentItemsFromOrder(order).join(" · ");
}
